import { gsap } from 'gsap';
import { Sequence } from "../../../core/displayobject/Sequence";
import { SanQuentin2 } from "../../SanQuentin2";
import { Helper } from "../../../core/utils/Helper";
import { SpinePlayer } from '../../../core/displayobject/SpinePlayer';

export class RevealerFull extends PIXI.Container {

    protected lever:Sequence;
    protected animReaveal:Sequence;
    protected animFX:Sequence;

    protected doubleReveal:SpinePlayer;

    protected _timeLine:gsap.core.Timeline;

    constructor (){
        super();
        this.initAnimations();
    }

    protected initAnimations():void{
        this.doubleReveal = this.addChild(new SpinePlayer("X_ways"))
        this.doubleReveal.alpha = 0;
    }

    public get revealDurr():number{
        return this.doubleReveal.fetchDuration("reveal_double");
    }

    public reveal():gsap.core.Timeline{

        this._timeLine = Helper.setTimeline(this._timeLine,{
            onStart:() => this.children.forEach(c => c.alpha = 1),
            onComplete:() => this.children.forEach(c => c.alpha = 0)
        });
        
        this._timeLine.add(this.doubleReveal.play({animation:"reveal_double"}));
      

        return this._timeLine;
    }
}